import axiosHttp from "services/axiosHttp";
import { REWARD_BASE_URL } from "configs/AppConfig";
import moment from "moment";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchTerminalSummary = createAsyncThunk("fetchTerminalSummary", async ({ user_channel, filters }, { rejectWithValue }) => {
	let start_date = "";
	let end_date = "";

	console.log("Redux - user_channel:", user_channel);
	console.log("Redux - filters:", filters);

	if (filters?.dates?.length === 2) {
		start_date = moment(filters.dates[0]).format("YYYY-MM-DD");
		end_date = moment(filters.dates[1]).format("YYYY-MM-DD");
	}

	const params = new URLSearchParams({
		channel: user_channel || "",
		startDate: start_date || "",
		endDate: end_date || "",
	});

	console.log("API URL:", `${REWARD_BASE_URL}terminal-wise-summary?${params}`);

	try {
		const response = await axiosHttp.get(`${REWARD_BASE_URL}terminal-wise-summary?${params}`);
		return response.data.data;
	} catch (err) {
		console.error("API Error:", err);
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const TerminalSummarySlice = createSlice({
	name: "TerminalSummarySlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},
	extraReducers: (builder) => {
		builder.addCase(fetchTerminalSummary.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});
		builder.addCase(fetchTerminalSummary.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});
		builder.addCase(fetchTerminalSummary.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export default TerminalSummarySlice.reducer;
